import React from "react";
import { arrayOf, shape, string, func, object } from "prop-types";
import { connect } from "react-redux";
import GreatBearOnboarding from "../components/GreatBearOnboarding/index";
import { markDocumentReadGB } from "../redux/actions";
import { getGreatBearInductionPackPDF } from "../api/profileApi";
import { forceDownload } from "./ResourceFolders/util";

const GreatBearOnboardingContainer = ({
  readingListDownloads,
  greatBearOnboarding,
  markDocumentReadFunc,
}) => {
  const getInductionPack = () => {
    getGreatBearInductionPackPDF().then((response) => {
      forceDownload(response, readingListDownloads[0].title);
    });
  };

  return (
    <GreatBearOnboarding
      readingList={readingListDownloads}
      greatBearOnboarding={greatBearOnboarding}
      markDocumentRead={markDocumentReadFunc}
      getCompletedDocument={getInductionPack}
    />
  );
};

GreatBearOnboardingContainer.propTypes = {
  markDocumentReadFunc: func.isRequired,
  greatBearOnboarding: object,
  readingListDownloads: arrayOf(
    shape({
      title: string.isRequired,
      link: string.isRequired,
    })
  ),
  requestGreatBearPdf: func,
};

const mapStateToProps = (state) => ({
  readingListDownloads: state.core.umbracoContent.greatBearReadingList,
  greatBearOnboarding: state.core.app.greatBear,
});

const mapDispatchToProps = {
  markDocumentReadFunc: markDocumentReadGB,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(GreatBearOnboardingContainer);
